
import React, {useEffect} from "react";
import ReactDOM from "react-dom";
import "./PortalModal.scss";

interface OverlayContent {
  header: string;
  body: string;
  actionTxt?: string;
  omnitureTxt?: string;
  trackingTxt?: string;
  bodyTxt2?: string;
}

interface PortalModalProps {
  overlayContent: OverlayContent;
  isOpen: boolean;
  onClose: Function;
  onAction?: Function;
  lastActiveEle?: React.ElementType
}

const PortalModal:React.FC<PortalModalProps> = ({ overlayContent, isOpen, onClose, onAction, lastActiveEle}) => {
  useEffect(() => {
    //@ts-ignore
    photoOrg.overlayNavigation.captureEleInOverlayForNonFdn($(".projectoverlaybg"));
  }, [])
  const keyDownCloseAction = (e) =>{
    if(e.key === " " || e.key === "Enter"){
      trackAndClose(e);
      //@ts-ignore
      photoOrg.overlayNavigation.turnOffCapturedElementsEventsForNonFdn($(".projectoverlaybg"), lastActiveEle);
    }
  }
  const trackAndClose = (e) => {
    onClose();
    let trackingTxt = e.currentTarget && e.currentTarget.getAttribute("tracking-text");
    if(trackingTxt){
      //@ts-ignore
      photoOrg.Util.trackLinksAndButtons(trackingTxt,'projectsPage');
    }
  }
  if (!isOpen) return null;

    
  return ReactDOM.createPortal(
    <div aria-labelledby ="overlay-header" dialog-name="projectoverlay" className="projectoverlaybg" role="dialog" aria-modal="true" data-reveal-listen data-reveal>
    <div id="projectdeleteConfirmation">
      <div className="confirmation-body">
        <div id="overlay-header" className="confirmation-header confirm-header-nobg">
          <h2>{overlayContent.header}</h2>
        </div>
        { onAction ?
        (<><div id="overlay-body" className="confirmation-header confirm-header-nobg">
          {overlayContent.body}
        </div>
        <div className="buttons-container">
          <ul className="flex-container">
            <li className="flex-item">
              <a tabIndex={0} button-name="cancel-button" role="button" tracking-text={overlayContent.trackingTxt} id="cancel-link" className="pill-border omniture_btn" onKeyDown={(e)=>keyDownCloseAction(e)} onClick={(e)=>trackAndClose(e)}>
                {/** @ts-ignore */}
                {photoOrg.translations.projects["action_container"]["Cancel"]}
              </a>
            </li>
            <li className="flex-item">
              <a tabIndex={0} id="action-link" button-name={overlayContent.omnitureTxt} role="button" className="pill omniture_btn" onKeyDown={(e)=>{if(e.key === " " || e.key === "Enter")onAction();}} onClick={(e)=>onAction(e)}>
                {overlayContent.actionTxt}
              </a>
            </li>
          </ul>
        </div></>) : (<>
          <div id="overlay-body" className="confirmation-header confirm-header-nobg">
          {overlayContent.body}
          <span className="icon-icon_device_mobile"></span> <br/>
          {overlayContent.bodyTxt2}
        </div>
          <div className="buttons-container">
          <a tabIndex={0} id="ok-link" role="button" className="pill" onKeyDown={(e)=>keyDownCloseAction(e)} onClick={(e)=>onClose(e)}>
             {/** @ts-ignore */}
            {photoOrg.translations.projects["ok_more"]}
          </a>
          </div></>
        ) 
        }
        {/** @ts-ignore */}
        <a tabIndex={0} role="button" aria-label={photoOrg.translations.projects["aria_label"]["close"]} className="close-project-overlay" onKeyDown={(e)=>keyDownCloseAction(e)} onClick={(e)=>onClose(e)}></a>
      </div>
    </div>
    </div>,
    document.getElementsByClassName('photo-Org')[0]
  );
};

export default PortalModal;
